import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  favoritesController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$timeout',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'authService',
    'EQuickAccessItems',
    'EDocumentStatus',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $timeout,
      revisionService,
      $filter,
      $state,
      $controller,
      authService,
      EQuickAccessItems,
      EDocumentStatus
    ) {
      'use strict';

      function itemsFilter(item) {
        return item.idStatus !== EDocumentStatus.TRASH_CAN && item.isFavorite;
      }

      function goToPage(page) {
        $state.go('home.favorites', { page: page });
      }

      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          revisionService.cancelLoadRevisions();
          $rootScope.$broadcast('loadFolder', EQuickAccessItems.FAVORITES);

          revisionService
            .loadRevisionsFavorites($scope.currentPage, $scope.pageSize)
            .then((data) => {
              $scope.count = data.items.length;

              $scope.totalItem = $scope.count;

              if ($scope.totalItem > $scope.limite) {
                $scope.limiteValor = $scope.limite;
                $scope.botaoAtivo = true; //Mostra o botão caso necessario
              } else {
                $scope.limiteValor = $scope.totalItem;
                $scope.botaoAtivo = false;
              }

              $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

              $scope.loading = false;
              if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                $scope.goToPage($scope.pageCount);
              } else {
                $scope.documents(data.items);

                $scope.groups = [];
                $scope.title = $filter('translate')('FAVORITES');

                $scope.description = $scope.getDescription(
                  $scope.currentPage,
                  $scope.pageSize,
                  $scope.count,
                  data.total
                );

                if (authService.authentication.email !== 'autologin') {
                  var date = $scope.columns.filter((c) => c.id === 'date')[0];
                  date.sorted = 'asc';
                  $scope.sortColumn(date);
                } else {
                  var title = $scope.columns.filter((c) => c.id === 'title')[0];
                  title.sorted = '';
                  $scope.sortColumn(title);
                }
              }

              authService.getUserAsync().then(user => {
                user.userPreferences.IdLastFolder = EQuickAccessItems.FAVORITES;
              });
            })
            .catch((err) => {
              if (
                err.status_code === 500 &&
                $scope.selectedTreeItem.Name === 'CHECKOUTS'
              ) {
                $scope.documents([]);
                return;
              }
              swal.fire(err.error, err.error_description);
            });
        }
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('FAVORITES');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO FAVORITES');
          $scope.noDocumentsMessage = $filter('translate')('NO FAVORITES MSG');

          if (!$state.params.page) {
            $state.go('home.favorites', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.pageSize = 100;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;

          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.configColumns();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
